export default "__VITE_ASSET__D99xKNf4__"